(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/init.js');

'use strict';

const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const Main = svs.iam_idp.Main;
svs.iam_idp.init = () => {
  ReactDOM.render(React.createElement(ErrorBoundary, null, React.createElement(Main, null)), document.getElementsByClassName('js-react-container')[0]);
};
svs.iam_idp.init();

 })(window);